import { render, staticRenderFns } from "./franchising-faqs.vue?vue&type=template&id=56dbc0e9&scoped=true&"
import script from "./franchising-faqs.vue?vue&type=script&lang=js&"
export * from "./franchising-faqs.vue?vue&type=script&lang=js&"
import style0 from "./franchising-faqs.vue?vue&type=style&index=0&id=56dbc0e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dbc0e9",
  null
  
)

export default component.exports